import {Navbar,Header} from "./Components";

import Auth from "../utils/auth";

export default {
	name: 'ModuleBox',
	components: {
		Navbar,
		Header
	},
	data(){
		return{
			Info:JSON.parse(Auth.getInfo()),
			AdminName:"",

			InitSum:0,
		}
	},
	methods:{
		AddWatermark() {
			// 如果在iframe内部，则不添加水印
			if (window.self !== window.top) {
				// console.log('如果在iframe内部，则不添加水印')
				return // 如果在iframe内部，则不添加水印
			}
			// console.log('准备添加水印')
			// 创建一个新的 Date 对象，它将自动获取当前日期和时间
			const currentDate = new Date()
			// 获取当前年份
			const year = currentDate.getFullYear()
			// 获取当前月份，注意月份是从 0 开始计数的，所以要加 1
			const month = currentDate.getMonth() + 1
			// 获取当前日期
			const day = currentDate.getDate()
			// 将获取到的年份、月份和日期格式化为所需的字符串格式
			const formattedDate = `${year}${month < 10 ? '0' : ''}${month}${day < 10 ? '0' : ''}${day}`
			
			const userName = this.AdminName;
			const text = userName ? userName + ' ' + formattedDate : '管理系统' + ' ' + formattedDate /// 水印内容
			
			// 这是直接使用css添加dom元素的方法实现
			// const watermarkClass = 'watermark' // 添加水印元素的类名
			const fontSize = '24px'
			const rotation = -30 // 旋转角度
			const opacity = 0.2 // 设置文字水印的透明度
			const spacing = 270 // 水印之间的间距
			
			const screenWidth = window.innerWidth
			const screenHeight = window.innerHeight
			
			const rows = Math.ceil(screenHeight / spacing)
			const cols = Math.ceil(screenWidth / spacing)
			
			for (let i = 0; i < rows; i++) {
				for (let j = 0; j < cols; j++) {
				// 检查是否已经存在相应位置的水印
				const existingWatermark = document.querySelector(`div[data-random-id][data-row="${i}"][data-col="${j}"]`)
				if (!existingWatermark) {
					const watermark = document.createElement('div')
					// watermark.className = watermarkClass // 添加类名
					watermark.dataset.randomId = Math.random()
					.toString(36)
					.substring(2, 15) // 使用 dataset 存储随机 ID
			
					watermark.style.position = 'fixed'
					watermark.style.top = `${i * spacing}px`
					watermark.style.left = `${j * spacing}px`
					watermark.style.width = 'auto'
					watermark.style.height = 'auto'
					watermark.style.pointerEvents = 'none'
					watermark.style.zIndex = '99999'
					watermark.style.color = '#C5C1C1' // 水印颜色
					watermark.style.fontSize = fontSize
					watermark.style.textAlign = 'center'
					watermark.style.opacity = opacity
					watermark.style.transform = `rotate(${rotation}deg)` // 水印旋转角度
					watermark.style.whiteSpace = 'nowrap' // 水印超出屏幕时不自动换行
					watermark.innerText = text
			
					document.body.appendChild(watermark)
				}
				}
			}
		},
		RemoveWatermark() {
			// 移除水印函数
			// 使用css生成水印时，用此方法删除水印
			const watermarks = document.querySelectorAll('div[data-random-id]')
			watermarks.forEach((watermark) => {
				watermark.parentNode.removeChild(watermark)
			})
		},
		WatermarkResize(){
			this.RemoveWatermark();
			this.AddWatermark();
		},

		GetSystemElement(){
			if(this.InitSum == 0){
				this.InitSum = 1;
				this.$refs.ComponentsHeader.GetSystemElement();
			}
		},
	},
	mounted(){
		this.AdminName = this.Info.AdminName;
		this.AddWatermark();

		window.addEventListener('resize', this.WatermarkResize);
	}
}